import {
    types
} from '../actions/types';

const INITIAL_STATE = {
    providers: '',
    data: {
        futureBokings: [],
        pastBookings: [],
    },
    details: null,
    provider: null,
    service: null,
    upcoming: [],
    awaitingBooking: null,
    tempBookingData: null,
    currentBookingClient: null,
    currentSelectedService: null
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.GET_ALL_DB_PROVIDERS:
            return {
                ...state,
                providers: action.payload
            };

        case types.GET_CLIENT_BOOKINGS:
            return {
                ...state,
                data: action.payload
            };

        case types.GET_ALL_CLIENT_BOOKINGS:
            return {
                ...state,
                data: {
                    ...state.data,
                    bookings: action.payload
                }
            };

        case types.CLEAR_ALL_BOOKINGS:
            return {
                ...state,
                data: {
                    ...INITIAL_STATE.data
                },
            }

        case types.GET_FUTURE_CLIENT_BOOKINGS:
            return {
                ...state,
                data: {
                    ...state.data,
                    futureBookings: (state.data.futureBookings) ? [...state.data.futureBookings, ...action.payload] : [...action.payload]
                }
            };

        case types.GET_PAST_CLIENT_BOOKINGS:
            return {
                ...state,
                data: {
                    ...state.data,
                    pastBookings: action.payload
                }
            };

        case types.SET_BOOKING_PROVIDER:
            return {
                ...state,
                provider: action.payload
            };

        case types.SET_BOOKING_SERVICE:
            return {
                ...state,
                service: action.payload
            };

        case types.SET_BOOKING_DETAILS:
            return {
                ...state,
                details: action.payload
            };
        case types.GET_NEW_CLIENT_BOOKING:
            // console.log('GOT A NEW BOOKING AT BOOKING REDUCER', action.payload);
            return {
                ...state,
                upcoming: (state.upcoming) ? [...state.upcoming, ...action.payload] : [...action.payload]
            }
        case types.AWAIT_NEW_BOOKING:
            // console.log('AWAITING NEW BOOKING. SPINNER SHOULD APPEAR');
            return {
                ...state,
                awaitingBooking: true
            }
        case types.CONFIRM_NEW_BOOKING:
            // console.log('CONFIRMED NEW BOOKING AT REDUCER. THE SPINNER SHOULD HIDE');
            return {
                ...state,
                awaitingBooking: false
            }
        case types.SAVE_TEMP_BOOKING_DATA:
            return {
                ...state,
                tempBookingData: action.payload
            }
        case types.SAVE_CURRENT_BOOKING_CLIENT:
            return {
                ...state,
                currentBookingClient: action.payload
            }
        case types.SAVE_CURRENT_SELECTED_SERVICE:
            return {
                ...state,
                currentSelectedService: action.payload
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/js/reducers/booking-reducer.js